module.exports = __webpack_public_path__ + "static/whatsapp-phone-es-b50688c3bad002aa122d8b1042ff787e.png";